// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.88.2/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.88.2/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.purchase-wrapper {
  display: flex;
  align-items: center;
  text-transform: uppercase;
  font-size: 0.9em;
  letter-spacing: 0.9px;
  color: #999;
}
.purchase-wrapper > * {
  flex: 1;
}
.purchase-wrapper .actions {
  flex: 0.3;
}

nb-card-header {
  padding: 1em;
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInB1cmNoYXNlLWhpc3RvcnkuY29tcG9uZW50LnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDRSxhQUFBO0VBQ0EsbUJBQUE7RUFDQSx5QkFBQTtFQUNBLGdCQUFBO0VBQ0EscUJBQUE7RUFDQSxXQUFBO0FBQ0Y7QUFBRTtFQUNFLE9BQUE7QUFFSjtBQUNFO0VBQ0UsU0FBQTtBQUNKOztBQUdBO0VBQ0UsWUFBQTtBQUFGIiwiZmlsZSI6InB1cmNoYXNlLWhpc3RvcnkuY29tcG9uZW50LnNjc3MiLCJzb3VyY2VzQ29udGVudCI6WyIucHVyY2hhc2Utd3JhcHBlciB7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gIHRleHQtdHJhbnNmb3JtOiB1cHBlcmNhc2U7XG4gIGZvbnQtc2l6ZTogMC45ZW07XG4gIGxldHRlci1zcGFjaW5nOiAwLjlweDtcbiAgY29sb3I6ICM5OTk7XG4gID4gKiB7XG4gICAgZmxleDogMTtcbiAgfVxuXG4gIC5hY3Rpb25zIHtcbiAgICBmbGV4OiAwLjM7XG4gIH1cbn1cblxubmItY2FyZC1oZWFkZXIge1xuICBwYWRkaW5nOiAxZW07XG59XG4iXX0= */`, "",{"version":3,"sources":["webpack://./src/app/home/purchase-history/purchase-history.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,qBAAA;EACA,WAAA;AACF;AAAE;EACE,OAAA;AAEJ;AACE;EACE,SAAA;AACJ;;AAGA;EACE,YAAA;AAAF;AACA,4wBAA4wB","sourcesContent":[".purchase-wrapper {\n  display: flex;\n  align-items: center;\n  text-transform: uppercase;\n  font-size: 0.9em;\n  letter-spacing: 0.9px;\n  color: #999;\n  > * {\n    flex: 1;\n  }\n\n  .actions {\n    flex: 0.3;\n  }\n}\n\nnb-card-header {\n  padding: 1em;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
